import { render } from "./TemplateBoxSlot.vue?vue&type=template&id=7345bdd7&scoped=true"
import script from "./TemplateBoxSlot.vue?vue&type=script&lang=js"
export * from "./TemplateBoxSlot.vue?vue&type=script&lang=js"

import "./TemplateBoxSlot.vue?vue&type=style&index=0&id=7345bdd7&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7345bdd7"]])

export default __exports__